import { UploadOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { t } from 'i18next'
import { useRef } from 'react'
import styled from 'styled-components'
import * as XLSX from 'xlsx'

const StyledButton = styled(Button)`
  height: 34px;
`

enum EFileType {
  CSV = 'csv',
  Excel = 'xlsx'
}
interface IProps {
  headerRow?: Array<string>
  dateFields?: Array<string>
  disabled?: boolean
  keyId?: string
  onChange?: (data: Array<any>) => void
}
const UploadFileExcelCsv = (props: IProps) => {
  const { dateFields, disabled, headerRow = [], onChange, keyId } = props
  const inputFileRef = useRef<any>(null)
  function handleFileUpload(event: any) {
    const file = event.target.files[0]
    const reader = new FileReader()
    const fileNameParts = file.name.split('.')
    const fileExtension = fileNameParts[fileNameParts.length - 1].toLowerCase()
    switch (fileExtension) {
      case EFileType.CSV:
        reader.onload = function (e: any) {
          const contents = e.target.result
          const data: any = []
          const lines = contents?.split('\n')
          lines.forEach((line: any) => {
            const columns = line.split(',')
            data.push(columns)
          })
          const dataObj = buildObjectFromData(data)
          if (onChange) {
            onChange(dataObj)
            inputFileRef.current.value = null
          }
        }
        reader.readAsText(file)
        break
      case EFileType.Excel:
        reader.onload = function (e: any) {
          const data = new Uint8Array(e.target.result)
          const workbook = XLSX.read(data, {
            type: 'array',
            dateNF: 'd"/"m"/"yyyy'
          })
          const worksheet = workbook.Sheets[workbook.SheetNames[0]]
          const jsonData = XLSX.utils.sheet_to_json(worksheet, {
            header: 1,
            cellDates: true
          } as any)
          const dataObj = buildObjectFromData(jsonData)
          if (onChange) {
            onChange(dataObj)
            inputFileRef.current.value = null
          }
        }
        reader.readAsArrayBuffer(file)
        break
    }
  }
  function buildObjectFromData(dataRaw: any) {
    const result: any = []
    if (!dataRaw && dataRaw.length < 2) {
      return result
    }
    const indexKey = headerRow.findIndex((r) => r === keyId)
    const data = dataRaw?.filter((item: any) => !!item?.[indexKey])

    for (let i = 1; i < data.length; i++) {
      const valueRow = data[i]
      const obj: any = {}

      for (let j = 0; j < headerRow.length; j++) {
        const header = headerRow[j]
        const value = valueRow[j]
        obj[header] = value
        if (dateFields?.includes(header)) {
          obj[header] = new Date((value - 25569) * 86400 * 1000)?.getTime()
        }
      }
      if (obj[keyId as string]) {
        result.push(obj)
      }
    }

    return result
  }
  return (
    <div>
      <StyledButton
        icon={<UploadOutlined />}
        size={'small'}
        disabled={disabled}
        onClick={() => inputFileRef.current?.click()}>
        {t('import-excel-csv')}
      </StyledButton>
      <input
        type="file"
        ref={inputFileRef}
        style={{ display: 'none' }}
        accept=".xlsx, .csv"
        disabled={disabled}
        onChange={handleFileUpload}
      />
    </div>
  )
}

export default UploadFileExcelCsv
